// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"636b6c9b","453":"57fb0d3e","464":"bce398fc","542":"6e4fa4e0","563":"4c89fcd4","939":"f99f7cd9"}[chunkId] + ".chunk.js";
};